/**
 * @desc 退出登录
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type LogoutParameter = never

const method = 'POST'
const url = '/auth/logout'

export const logoutApi = (
  params?: LogoutParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    params,
    ...config
  })
}

logoutApi.method = method
logoutApi.url = url
